module.exports={
	"Form": "AccountCreateManifest",
	"Scope": "Account-Create",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Account-Create-Identity",
				"Group": "Account-Create-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-Create-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				]
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-Create-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-Create-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-Create-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-Create-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Create-Details",
				"Group": "Account-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
